import { RefObject, useEffect } from 'react';

export function useClickOutside<T extends HTMLElement | null>(
  ref: RefObject<T>,
  handler: () => void,
  enabled = true
): void {
  useEffect(() => {
    if (!enabled) return;
    const onMousedown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        handler();
      }
    };
    document.addEventListener('mousedown', onMousedown);
    return () => document.removeEventListener('mousedown', onMousedown);
  }, [ref, handler, enabled]);
}
